"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/** Reusable loading spinner. Use instead of duplicating inline spinner markup (CRM, Calendar, desktop-admin App, etc.). */
const Spinner = ({ size = 40, color = '#667eea', message, style, }) => ((0, jsx_runtime_1.jsxs)("div", { style: { textAlign: 'center', padding: 40, ...style }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                width: size,
                height: size,
                border: `4px solid #f3f3f3`,
                borderTop: `4px solid ${color}`,
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px',
            }, role: "status", "aria-label": message ?? 'Loading' }), message && (0, jsx_runtime_1.jsx)("p", { style: { color: '#666', margin: 0 }, children: message })] }));
exports.default = Spinner;
